<template>
  <div class="production_wrap">
    <div class="production_img" id="cpjz">
      <div class="production_img_inner">
        <div class="img_desc">良悦数据中台解决方案</div>
        <div class="img_tit">整合、治理数据资产，提供智能服务与分析，赋能业务决策</div>
<!--        <div class="img_desc">从设计到交付，数字化全链贯通，一站式数字化制造服务，让效率与质量双擎驱动</div>-->
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="系统定位" name="first"></el-tab-pane>
        <el-tab-pane label="业务流程" name="second"></el-tab-pane>
        <el-tab-pane label="核心功能" name="third"></el-tab-pane>
        <el-tab-pane label="设备支持" name="fourth"></el-tab-pane>
        <el-tab-pane label="关联模块" name="five"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="service-card" >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">系统定位</div>
          <div class="production_desc">企业数据资产化的核心引擎</div>
        </div>
      </div>

      <div class="production_box" >
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/sjyth.png"/>
            <div>数据一体化</div>
            <div class="content">打破ERP、MES、CRM等系统数据孤岛，构建全域数据湖仓一体化体系</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/zlbzh.png"/>
            <div>治理标准化</div>
            <div class="content">通过元数据管理、质量规则引擎，实现数据血缘追溯与合规管控</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/fwbjh.png"/>
            <div>服务敏捷化</div>
            <div class="content">提供API、标签工厂、自助分析等工具，支撑业务部门快速获取数据价值</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/jczcjz.png"/>
            <div>智能决策基座</div>
            <div class="content">融合AI算法与实时计算，驱动预测性维护、高效营销等场景落地</div>
          </div>
        </div>
      </div>
</div>

    <div class="tedian" >
      <div class="production_title_wrap flow-title">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title" id="cptd">良悦数据中台解决方案业务流程</div>
          </div>
        </div>
      </div>
      <div class="title_card"><img src="../../assets/img/solution/sjzt-title-bg.svg"/></div>
      <div class="production_card">
        <img src="../../assets/img/solution/SJZT.svg" class="gaizao"/>
      </div>
    </div>

      <div class="production_title_wrap" >
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title"  id="fwfc">核心功能</div>
          </div>
        </div>

          <el-row class="card_wrap " type="flex" >
            <el-col
                class="brain_item"
                :lg="7"
                :sm="11"
                :xs="24"
                v-for="(item, index) in cardList"
                :key="index"
            >
              <div class="item_bg"></div>
              <el-row style="z-index: 2">
                <el-col :span="24" :xs="6">
                  <div class="item_bg_div"><img :src="item.src" alt="" class="img_item"/></div>
                </el-col>
                <el-col :span="24" :xs="18" class="con">
                  <div class="item_title">{{ item.title }}</div>
                  <div class="item_desc">{{ item.desc1 }}</div>
                </el-col>
              </el-row>

              <!--        <div class="item_title">{{ item.title }}</div>-->
              <!--        <div class="item_desc">{{ item.desc }}</div>-->
              <!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
              <!--        <div class="item_bg"></div>-->
            </el-col>
          </el-row>
        <span id="gzfx"></span>
      </div>
    <div class="tedian1"  >
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">设备支持</div>
          </div>
        </div>
      </div>
      <div class="production_card">
        <el-row class="row-area" id="glmk">
          <el-col :span="4" :xs="24" class="col-area">
            <div class="first-btn">多终端适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/pc.svg" />PC端
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/app.svg" />手机APP
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/xcx.svg" />微信小程序
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/dpd.svg" />大屏端
          </el-col>
        </el-row>
        <el-row class="row-area">
          <el-col :span="4"  :xs="24" class="col-area">
            <div class="first-btn">数据中心适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/crh.svg" />超融合
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/xnh.svg" />虚拟化
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/syy.svg" />私有云
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/ctit.svg" />传统IT架构
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">关联模块</div>
        </div>
      </div>
      <div class="production_card">
      <el-row :gutter="20" class="guanlian-row-area">
        <el-col :span="12" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl1.jpg" class="image">
            <span class="guanli-title">纵向关联</span>
            <div class="guanli-area">
              <span>企业资源管理系统ERP</span>
              <div class="time">抽取财务、供应链数据，反馈库存预测结果指导采购计划</div>
              <span>制造执行系统MES</span>
              <div class="time">实时获取设备状态，输出预测性维护建议至维修工单</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl2.jpg" class="image">
            <span class="guanli-title">横向扩展</span>
            <div class="guanli-area">
              <span>大数据分析平台</span>
              <div class="time">提供清洗后的主题数据，支撑敏捷报表与可视化分析</div>
              <span>AI中台</span>
              <div class="time">输送特征数据训练模型，接收推理结果反哺业务系统</div>
            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="8">-->
<!--          <el-card :body-style="{ padding: '0px' }">-->
<!--            <img src="../../assets/img/solution/gl3.jpg" class="image">-->
<!--            <div class="guanli-area">-->
<!--              <span>AI与大数据</span>-->
<!--              <div class="time">分析历史数据预测故障，生成智能优化建议</div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
      </el-row>
      </div>
    </div>
    <div class="tedian1 padding80" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      cardList: [
        {
          src: require('@/assets/img/solution/sjzt-hx-1.png'),
          title: '全域数据集成',
          desc1: '支持关系型数据库、时序数据库、日志文件等50+数据源，兼容OPC UA、Modbus等工业协议',
        },
        {
          src: require('@/assets/img/solution/sjzt-hx-2.png'),
          title: '实时计算引擎',
          desc1: '基于Flink实现设备状态流式分析，秒级响应异常事件（如温度骤升告警）',
        },
        {
          src: require('@/assets/img/solution/sjzt-hx-3.png'),
          title: '数据开发工厂',
          desc1: '可视化编排数据清洗、关联、聚合任务，内置200+制造业指标模板（如设备稼动率、订单交付周期）',
        },{
          src: require('@/assets/img/solution/sjzt-hx-4.png'),
          title: '资产目录中心',
          desc1: '自动化构建数据资产地图，支持分级授权（如车间主任仅可访问本厂数据）',
        },{
          src: require('@/assets/img/solution/qms-hx-7.png'),
          title: '质量治理平台',
          desc1: '定义完整性、一致性、时效性规则，自动生成数据健康度评分与整改建议',
        },{
          src: require('@/assets/img/solution/sjzt-hx-6.png'),
          title: '安全管控体系',
          desc1: '字段级脱敏（如隐藏客户手机号）、操作审计日志、动态权限审批流',
        }

      ],
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 500){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1400){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 2300){
          this.activeName="fourth"
        }
        if(document.documentElement.scrollTop > 2800){
          this.activeName="five"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('cptd');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="five"){
        const element = document.getElementById('glmk');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.flow-title{
  padding-bottom: 0 !important;
}
.tedian1 {
  background-color: rgba(245, 247, 250, 1);
  padding: 5px 0 5px 0;
}
.tedian{
  background-color:#EDF5FF;
  padding: 5px 0 5px 0 ;
  .title_card{
    width: 80%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    img{
      width: 100%;
      margin-bottom: 0;
    }
  }
  .production_card{
    margin-top: 20px !important;
  }

}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  .production_img {
    background: url('../../assets/img/solution/sjzt-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 70% 100%;
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
  }

  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .production_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 10PX;
      margin-bottom: 30PX;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .production_item {
      width: calc(100% / 4 - 12px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);

      }
      .title{
        width: 100%;
        font-size: 24px;
        color: rgba(37, 53, 84, 1);
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
          font-weight: bold;
        }
        img{
          margin-bottom: 10px;
          width: 60px;
          @media screen and (max-width: 768px) {
            width:40PX;
            float: left;
            margin-right: 15PX;
          }
        }
        .content{
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(37, 53, 84, 0.6);
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-left: 55PX;
            font-weight: normal;
          }
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }
    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  padding-bottom: 20px;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-bottom: 20PX;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    border-radius: 4px;
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 10PX;
      //justify-content: center;
      margin-top: 20PX;
    }
    .img_item {
      margin-top: 18px;
      width: 60% ;
      @media screen and (max-width: 768px) {
        width:50PX;
        height: 50PX;
        margin-top: 0;
      }
    }
    &:hover{
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      //background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      //border: 1px solid #fff;

    }

    .item_bg_div{
      width:100px;
      height:100px;
      background:linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
      box-shadow: 0 0.2rem 1rem 0.2rem rgba(12, 28, 56, 0.08);
      border: 2px solid #fff;
      border-radius: 50%;
      text-align: center;
      margin: auto;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        width: 70PX;
        height: 70PX;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10PX;
      }
      &:hover{
        box-shadow: 0 0.2rem 1.5rem 0.2rem rgba(12, 28, 56, 0.128);
        border: 1px solid #fff;
      }
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: center;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: left;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      margin: auto;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 1.2rem;
        margin-left: 0;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
</style>